module.exports = __webpack_public_path__ + "static/Neucha-Regular-ba10e84e04783d0cf957000b0386d2a9.ttf";